import React, { Component } from "react";
import FullScreen from "../DropZone";
import createZwibbler from "./createZwibbler";
import zwibblerExternalAPI from "./ExternalApi";

class Zwibbler extends Component {
  state = {
    zwibblerStarted: false,
    showPropertyPanel: false,
    demoModePillExpanded: false
  };

  startZwibbler = (config = {}) => {
    const { exposeMethods, callFMScript } = this.props;

    if (!this.state.zwibblerStarted) {
      this.started = true;
      this.zwibbler = createZwibbler(config, callFMScript);
      this.zwibbler.gibbler = this.props.activated ? true : false;

      //grab the property panel, and add it to slising panel
      const panel = this.zwibbler._getPropertyPanelElement();
      panel.removeAttribute("style");
      this.propertyPanel.appendChild(panel);

      //expose the szibbler external api
      exposeMethods(zwibblerExternalAPI(this.zwibbler));
      this.setState({
        zwibblerStarted: true
      });
    }
  };

  componentDidMount() {
    const { exposeMethods } = this.props;
    exposeMethods({
      startGoDraw: options => {
        this.startZwibbler(options);
      },
      showPropertyPanel: () => {
        this.setState({ showPropertyPanel: true });
      },
      hidePropertyPanel: () => {
        this.setState({ showPropertyPanel: false });
      }
    });
  }

  componentWillUnmount() {
    if (this.zwibbler) {
      this.zwibbler.destroy();
    }
  }

  handleDropFiles = files => {
    const file = files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const dataURL = reader.result;
      this.zwibbler.beginTransaction();
      const imgId = this.zwibbler.createNode("ImageNode", {
        url: dataURL
      });
      this.zwibbler.translateNode(imgId, 20, 30);
      this.zwibbler.commitTransaction();
    };
    reader.readAsDataURL(file);
  };

  render() {
    return (
      <div className="App">
        <div
          id="pp"
          style={{
            boxShadow: "-2px 0px 6px rgba(0,0,0,0.70)",
            right: this.state.showPropertyPanel ? 0 : -264,
            transition: "right 0.5s ease-in-out",
            top: 0,
            height: "100%",
            width: 240,
            position: "absolute",
            zIndex: 99999
          }}
          ref={ref => {
            this.propertyPanel = ref;
          }}
        >
          <div
            onClick={() => {
              this.setState({ showPropertyPanel: false });
            }}
            style={{ marginBottom: "4px" }}
          >
            [ X ]
          </div>
        </div>

        <FullScreen onDropFiles={this.handleDropFiles}>
          <div id="zwibbler" style={{ height: "100vh" }} />
          {this.state.zwibblerStarted ? null : "loading..."}
        </FullScreen>
      </div>
    );
  }
}

export default Zwibbler;



// WEBPACK FOOTER //
// ./src/components/Zwibbler/index.js